import type { components } from "#/schema";

export function isLeerjaarValid(
  leerjaar: components["schemas"]["SociaalEmotioneelThemaDetailModel"] | undefined,
): "valid" | "empty" | "invalid" {
  if (!leerjaar) return "empty";

  const beweegdoelen = leerjaar.sociaalEmotioneelDoelen ?? [];

  const hasAtleastOneBeweegdoelFilled = beweegdoelen.some(
    (beweegdoel) => beweegdoel.description && beweegdoel.description.trim() !== "",
  );

  if (!leerjaar.name && !hasAtleastOneBeweegdoelFilled) {
    return "empty";
  }

  // not valid if name is not filled and has less than 3 beweegdoelen
  if (!leerjaar.name || beweegdoelen.length < 3) {
    return "invalid";
  }

  // not valid if none of the beweegdoelen are filled
  if (beweegdoelen.some((beweegdoel) => !beweegdoel.description)) {
    return "invalid";
  }

  return "valid";
}
